import { useTranslation } from 'react-i18next';

import { data } from 'services';
import { getDateTime, getRackName } from 'services/types';
import { InfoBlock } from 'libs/ui';

export const EventInfo = ({ close, row }) => {
  const { t } = useTranslation();

  if (!row) {
    return null;
  }

  const title = row.message ?? '';
  const fields = [
    { title: t('grid.Время'), value: getDateTime(row.timestamp) },
    { title: t('grid.Источник'), value: data.getDictValue('rack_type', row.source_type) },
    { title: '№', value: getRackName(row.source) },
    { title: t('grid.Приоритет'), value: data.getDictValue('events.type', row.type) },
  ];

  return <InfoBlock title={title} close={close} fields={fields} info={row} />;
};
